import { render, staticRenderFns } from "./AppTipTap.vue?vue&type=template&id=3047f556&"
import script from "./AppTipTap.vue?vue&type=script&lang=js&"
export * from "./AppTipTap.vue?vue&type=script&lang=js&"
import style0 from "./AppTipTap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports